import AllWorks from "@/components/site/AllWorks";
import ContactSection from "@/components/site/ContactSection";
import { usePageMeta } from "@/lib/usePageMeta";

export default function Portfolio() {
  usePageMeta("Bütün işlərimiz", "livemedia.az portfoliosu: veb saytlar, veb tətbiqlər, mobil tətbiqlər, dizayn, loqolar, Telegram botlar və TikTok canlı yayım oyunları.");
  return (
    <div data-testid="portfolio-page">
      <AllWorks standalone />
      <ContactSection />
    </div>
  );
}
